<template>
  <div class="case">
    <div class="content">
      <div class="attrs">
        <div>线索名称：{{ item.name }}</div>
        <div>
          线索来源：{{ item.source | enumMessage(AllEnums.CRM_CUSTOMER_SOURCE) | dash }}
        </div>
        <div>
          手机号：<a
            @click.stop
            v-if="item.mobile"
            :href="`tel:${item.mobile}`"
            class="phone"
            >{{ item.mobile }} <van-icon name="phone"
          /></a>
          <span v-else>-</span>
        </div>
        <div>跟进内容：{{ item.contactLastContent | dash }}</div>
        <div>
          下次联系时间：{{ item.contactNextTime | dateFormat("YYYY-MM-DD") }}
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="footer">
      <div class="buttons">
        <button class="close" @click.stop="onActionClick('跟进', item)">
          跟进
        </button>
        <button class="close" @click.stop="onActionClick('转为客户', item)">
          转为客户
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    orderStatus: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {};
  },
  methods: {
    onActionClick(action, item) {
      this.$emit("actionClick", action, item);
    },

    // 详情
    goDetail(item) {
      this.$router.push({
        name: "CaseDetail",
        params: {
          homeNo: item.homeNo,
        },
        query: { bizNo: item.applyBizNo, readonly: true },
      });
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.success {
  color: #07c160;
}

.danger {
  color: #ff4848;
}

.warning {
  color: #fa9540;
}

.case {
  background: #ffffff;
  border-radius: 4px;
  position: relative;
  user-select: text;

  &::before {
    content: " ";
    position: absolute;
    left: 0px;
    top: 12px;
    width: 4px;
    height: 32px;
    background: #3c86ff;
    border-radius: 0 100px 100px 0px;
  }

  .content {
    position: relative;
    display: flex;

    .attrs {
      flex: 1;
      padding: 18px;

      div {
        color: #787b84;
        font-size: 12px;
        line-height: 1.8em;
        word-break: break-all;
      }
      .phone {
        color: #3c86ff;
      }
    }
  }

  .line {
    height: 1px;
    background: #f1f2f7;
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    height: 47px;
    line-height: 47px;
    font-size: 12px;

    .buttons {
      button {
        font-size: 12px;
        letter-spacing: 0;
        font-weight: 500px;
        border: 1px solid currentColor;
        border-radius: 2px;
        padding: 7px 18px;
        margin-right: 9px;
        background: transparent;
        box-sizing: border-box;

        &.expire {
          color: #ff9f00;
        }

        &.feedback {
          color: #4cb84c;
        }

        &.close {
          background: #3c86ff;
          color: #fff;
          border-color: #3c86ff;
        }
      }
    }
  }
}
</style>
